import { render, staticRenderFns } from "./RelatedRatioDialog.vue?vue&type=template&id=1f029b9c&scoped=true"
import script from "./RelatedRatioDialog.vue?vue&type=script&lang=js"
export * from "./RelatedRatioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f029b9c",
  null
  
)

export default component.exports